<template>
  <div class="main">
      <div v-if="baustelle.length">
        <h2 class="heading">Bauvorhaben {{ baustelle[0].adresse }}, {{ baustelle[0].bauherr }}</h2>
        <table id="testTable">
          <tbody>
            <tr>
              <th scope="row">Bauherr</th>
              <td>{{baustelle[0].bauherr}}</td>
            </tr>
            <tr>
              <th scope="row">Bauvorhaben</th>
              <td>{{baustelle[0].bvh}}</td>
            </tr>
            <tr>
              <th scope="row">Baustellenadresse</th>
              <td>{{baustelle[0].adresse}}</td>
            </tr>
            <tr>
              <th scope="row">Auftraggeber</th>
              <td>{{baustelle[0].auftraggeber}}</td>
            </tr>

            <tr>
              <th scope="row">Rechnungsempfänger</th>
              <td>{{baustelle[0].empfaenger}}</td>
            </tr>
            <tr>
              <th scope="row">Rechnungsadresse</th>
              <td>{{baustelle[0].rechnungsadresse}}</td>
            </tr>
            <tr>
              <th scope="row">PLZ, Ort</th>
              <td>{{baustelle[0].plz}}</td>
            </tr>

            <tr>
              <th scope="row">UID Nummer</th>
              <td>{{baustelle[0].uid}}</td>
            </tr>
            <tr>
              <th scope="row">Auftragssumme netto</th>
              <td>{{baustelle[0].auftragssumme.toLocaleString('de-DE', {minimumFractionDigits: 2})}} €</td>
            </tr>
            <tr>
              <th scope="row">Zahlungskonditionen</th>
              <td>{{baustelle[0].zkn}}</td>
            </tr>
            <tr>
              <th scope="row">Auftragsdatum</th>
              <td>{{baustelle[0].auftragsdatum | formatStrDate }}</td>
            </tr>
            <tr>
              <th scope="row">Auftragsnummer</th>
              <td>{{baustelle[0].auftragsnummer}}</td>
            </tr>
            <tr>
              <th scope="row">Leistungszeitraum</th>
              <td>{{baustelle[0].beginn | formatMonthDate }} – {{baustelle[0].ende | formatMonthDate}}</td>
            </tr>
            <tr>
              <th scope="row">Anmerkungen</th>
              <td>{{baustelle[0].info}}</td>
            </tr>
            <tr>
              <th scope="row">Erstellt am</th>
              <td>{{baustelle[0].createdOn | formatDate }}</td>
            </tr>
            <tr>
              <th scope="row">Erstellt von</th>
              <td>{{baustelle[0].userName}}</td>
            </tr>
          </tbody>
        </table>
        <h2>Zahlungsplan</h2>
        <table class="button-table" v-if="baustelle[0].zahlungsplan">
          <tbody>
            <tr class="table-head">
              <th>TR</th>
              <th>Datum</th>
              <th>Rg. Nr.</th>
              <th>Leistungsstand</th>
              <th>Leistungszeitraum</th>
              <th>Rechnungsbetrag</th>
              <th>+20% Mwst</th>
              <th>Verrechnet</th>
              <th>Bezahlt</th>
              <th>Summe bezahlt</th>
            </tr>
            <tr v-for="(zp, index) in baustelle[0].zahlungsplan" v-bind:key="zp.id">
              <th scope="row">TR {{ zp.TR }}</th>
              <td>{{ zp.datum | formatStrDate }}</td>
              <td>{{ zp.rgnr }}</td>
              <td>{{ zp.leistungsstand }} %</td>
              <td>{{ lstngsstnd(index) }}</td>
              <td
                v-if="zp.rechnungsbetrag"
              >{{ zp.rechnungsbetrag.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} €</td>
              <td v-else></td>
              <td
                v-if="zp.rechnungsbetrag"
              >{{ (zp.rechnungsbetrag * 0.2 + zp.rechnungsbetrag).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} €</td>
              <td v-else></td>
              <td v-if="zp.verrechnet">&#10004;</td>
              <td v-else>&#10006;</td>
              <td v-if="zp.bezahlt">&#10004;</td>
              <td v-else>&#10006;</td>
              <td
                v-if="zp.summe"
              >{{ zp.summe.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <p>Kein Zahlungsplan vorhanden</p>
        </div>

        <div>
          <h2>Zusammenfassung</h2>
          <table>
            <tbody>
              <tr class="table-head">
                <th>Bisher verrechnet</th>
                <th>Offen</th>
                <th>Aktueller Leistungsstand</th>
                <th>Nächste Rechnung</th>
              </tr>
              <tr>
                <td>{{ bezahlt.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
                <td>{{ offen.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
                <td v-if="leistungsstand">{{ leistungsstand }} %</td>
                <td v-else>–</td>
                <td v-if="nRg">{{ nRg | formatStrDate }}</td>
                <td v-else>–</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="buttons">
          <button class="button btn-edit warn" @click="deleteBst">Löschen</button>
        </div>
    </div>
</div>


</template>

<script>
const fb = require("../fbConfig");
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { currentUser } from "../fbConfig";
import router from "../router";

export default {
  props: ["id"],
  data() {
    return {
      baustelle: [],
    };
  },
  created() {
    fb.archiv
      .doc(this.id)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log("No such document!");
        } else {
          this.baustelle.push(doc.data());
        }
      })
      .catch(err => {
        console.log("Error getting document", err);
      });
  },
  methods: {
    lstngsstnd(index) {
      let dt_current = this.baustelle[0].zahlungsplan.filter(
        el => el.TR == index + 1
      );
      let dt_c = dt_current[0].datum;
      dt_c = moment(dt_c).format("DD.MM.YYYY");
      let dt_p;
      if (index + 1 > 1) {
        let dt_past = this.baustelle[0].zahlungsplan.filter(
          el => el.TR == index
        );
        dt_past = dt_past[0].datum;
        dt_p = moment(dt_past).format("DD.MM.YYYY");
      } else {
        dt_p = moment(this.baustelle[0].beginn).format("DD.MM.YYYY");
      }
      return dt_p + " - " + dt_c;
    },
    deleteBst() {
      fb.archiv
        .doc(this.id)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          router.push({ name: "Archiv" });
        })
        .catch(err => {
          console.error("Error removing document: ", err);
        });
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    bezahlt: function() {
      let a = [];
      this.baustelle[0].zahlungsplan.forEach(el => {
        if (el.bezahlt) {
          a.push(el.rechnungsbetrag);
        }
      });
      return a.reduce((a, b) => a + b, 0);
    },
    offen: function() {
      return parseInt(this.baustelle[0].auftragssumme) - this.bezahlt;
    },
    leistungsstand: function() {
      let a = [];
      this.baustelle[0].zahlungsplan.forEach(el => {
        if (el.bezahlt) {
          a.push(el.leistungsstand);
        }
      });
      return a[a.length - 1];
    },
    nRg: function() {
      let a = [];
      this.baustelle[0].zahlungsplan.forEach(el => {
        if (!el.bezahlt) {
          a.push(el.datum);
        }
      });
      return a[0];
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD.MM.YYYY");
    },
    formatStrDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    formatMonthDate(date) {
      return moment(date).format("MMM YYYY");
    }
  }
};
</script>

<style scoped>
.main {
  margin-top: 100px;
  background: #eeeeee;
  padding: 20px;
  border-radius: 20px;
}

.heading {
  margin-top: 0;
}

table {
  width: 65%;
  text-align: left;
  border-collapse: collapse;
}

td,
th {
  border: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.button-table {
  width: 90%;
}

.button-table td:last-of-type {
  text-align: center;
}

.btn-edit {
  margin-top: 10px;
  margin-right: 5px;
  margin-left: 2px;
}

.row-buttons {
  display: flex;
}

.row-button {
  border: none;
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 2px;
  border: 1px solid #999;
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.row-button:hover {
  border: 1px solid #2c3e50;
  color: #fff;
  background: #2c3e50;
}

.buttons {
  margin-top: 10px;
}

.archi {
  background-color: rgb(143, 143, 143);
  border: 1px solid rgb(143, 143, 143);
}

.archi:hover {
  border: 1px solid rgb(143, 143, 143);
  background-color: transparent;
  color: rgb(143, 143, 143);
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100px;
  font-size: 15px;
}

.warn {
  background-color: rgb(209, 49, 0);
  border: 1px solid rgb(209, 49, 0);
}

.warn:hover {
  border: 1px solid rgb(209, 49, 0);
  background-color: transparent;
  color: rgb(209, 49, 0);
}
</style>>